// Shared display helpers for the public /events list and /events/:eventId detail page.
// Event dates are stored as naive local (Eastern) times.

export const EVENT_TYPE_COLORS = {
  tournament: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300',
  seminar: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300',
  belt_test: 'bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300',
  open_house: 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300',
  special: 'bg-yellow-100 dark:bg-yellow-900/40 text-yellow-800 dark:text-yellow-300',
};

export const EVENT_TYPE_LABELS = {
  tournament: 'Tournament',
  seminar: 'Seminar',
  belt_test: 'Belt Test',
  open_house: 'Open House',
  special: 'Special Event',
};

export const eventTypeColor = (event) => EVENT_TYPE_COLORS[event.event_type] || EVENT_TYPE_COLORS.special;
export const eventTypeLabel = (event) => EVENT_TYPE_LABELS[event.event_type] || event.event_type;

export const formatDate = (dateString) =>
  new Date(dateString).toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

export const formatTime = (dateString) =>
  new Date(dateString).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

// An event stays upcoming until its end time, or through the end of its day when
// there is no end time, so it isn't shown as past during day-of check-in.
export const isUpcoming = (event, now = new Date()) => {
  if (event.end_date) return new Date(event.end_date) >= now;
  const start = new Date(event.date);
  return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1) > now;
};

// "Day-of check-in 9:30–10:30 AM" -> "9:30–10:30 AM"; null when the description doesn't say.
export const checkInWindow = (event) => {
  const match = (event.description || '').match(
    /check-in\s+(\d{1,2}(?::\d{2})?\s*(?:[AP]M)?\s*[–-]\s*\d{1,2}(?::\d{2})?\s*[AP]M)/i
  );
  return match ? match[1] : null;
};

export const eventPath = (event) => `/events/${encodeURIComponent(event.id)}`;

export const mapsUrl = (location) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location)}`;
